import { queryClient } from "@/queryClient";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const searchSchema = z.object({
  id: z.string().optional(),
});

export const Route = createFileRoute("/uns/metadatabundles/")({
  staticData: {
    title: "navigation.metadatabundles",
  },
  loader: async () => {
    const { queries } = await import("@/modules/uns/metadatabundles/services/requests");
    return queryClient.ensureQueryData(queries.getMetadatabundles);
  },
  validateSearch: searchSchema,
});
